import React, { useState } from "react";
import {
  Typography, Box, Skeleton, List, ListItem, ListItemIcon, ListItemText, useTheme, Grid2
} from "@mui/material";
import Highcharts from "highcharts/highstock";
import PieChart from "highcharts-react-official";
import { RxSize } from "react-icons/rx";
import { useGetRiskDistributionQuery } from '../../../store/slices/apis/riskDashboardSlice';
import RiskPopup from "./RiskPopup";
import { useParams } from "react-router-dom";
import HighchartsReact from "highcharts-react-official";
import { FaSquareFull } from "react-icons/fa6";


const RiskDistributionGraph = () => {
  const { projectId } = useParams();
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { data: RiskDistribution = [], isLoading } = useGetRiskDistributionQuery({
    project_id: projectId
  });

  const colorsArray = ['#FDCA40', '#3E756D', '#E72B33', '#295477',];
  const distributionData = RiskDistribution?.data?.map((item, index) => ({
    y: item.count,
    value: item.count,
    color: colorsArray[index],
    name: item.package,
  }));




  const options = {
    chart: {
      type: "pie",
      width: 220,
      height: 220,
      marginBottom: 40,
      marginTop: 0,
    },
    title: {
      text: 'EPC',
      style: {
        fontWeight: 700,
        fontSize: '28px',
        color: '#414D55',
        lineHeight: '40px'
      },
      align: 'center',
      verticalAlign: 'middle',
      y: 10,
    },
    subtitle: {
      useHTML: true,
      text: '',
      //text: '<div style="width: 26px; height: 26px; background-color: white; border-radius: 40%; padding-top: 3px;-moz-box-shadow: 1px 1px 4px #f3f3f3;-webkit-box-shadow: 1px 1px 4px #f3f3f3;box-shadow: 0 0 4px #f3f3f3;">58</div>',
      align: 'center',
      verticalAlign: 'middle',
      style: { "fontSize": "12px", "fontWeight": "500", "color": "#414D55", "lineHeight": "20px", "letterSpacing": "0.5px" },
      y: -85, x: -65
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function () {
        // Customize the hover text here
        return `<b style='color: ${this.color}'>${this.name}</b>: ${this.y}`;
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        borderWidth: 0,
        borderRadius: 0,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
        innerSize: 100,
        point: {
          events: {
            click: function () {
              setPopupData({
                name: this.name,
                value: this.y,
              });
              setOpen(true);
            }
          }
        },
      }
    },
    series: [
      {
        name: "",
        color: "#006600",
        lineWidth: 1,
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 3,
          states: {
            hover: {
              enabled: true,
              lineWidth: 1
            }
          }
        },
        data: distributionData,
      }
    ]
  };

  if (isLoading) {
    return (
      <Box sx={{ backgroundColor: "white", marginTop: "10px", borderRadius: "5px", padding: '20px' }}>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width={220} height={80} />

        <Grid2 container>
          <Grid2 size={{ xs: 12, md: 7 }}>
            {[...Array(3)].map((_, index) => (
              <Grid2 container direction="row" spacing={1} key={index} sx={{ marginLeft: "10px", paddingTop: '5px' }}>
                <Box sx={{ width: "130px", padding: "8px" }}>
                  <Skeleton variant="text" width={100} height={20} />
                </Box>
                <Box sx={{ width: "30px", padding: "4px" }}>
                  <Skeleton variant="text" width={20} height={28} />
                </Box>
              </Grid2>
            ))}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Skeleton variant="circular" width={175} height={175} />
          </Grid2>
        </Grid2>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ p: 2, maxWidth: "100%", width: "100", height: { xs: "auto", md: "251px" }, border: "1px solid #D8D8D8", mt: "10px", borderRadius: "12px", overflow: "hidden", backgroundColor: "white" }}>
        <Box sx={{}}>
          <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}`, }}>
            Risk Distribution by EPC
          </Typography>
          <Typography sx={{ mt: "5px", color: "#5052588A", fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px', }}>
            Risks across EPC phases to target controls where they matter most.
          </Typography>
        </Box>
        {distributionData?.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 6
            }}
          >
            <Typography sx={{ fontSize: "16px", color: "#999", fontWeight: 500 }}>
              No data available to display the chart.
            </Typography>
          </Box>
        ) : (

          <Box
            sx={{
              display: { xs: "block", md: "flex" },
              justifyContent: "space-between",
              alignItems: "flex-start",
              mt: 2,
              gap: 2,
            }}
          >
            {/* List Section */}
            <Box sx={{ flex: 1 }}>
              <List sx={{ padding: 0, mb: 4, }}>
                {distributionData?.map((val, index) => (
                  <ListItem key={index} sx={{ paddingLeft: 0 }}>
                    <ListItemIcon sx={{ minWidth: '20px' }}>
                      <FaSquareFull
                        style={{ color: `${val?.color}`, height: '14px', width: '14px' }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            component="span"
                            sx={{
                              whiteSpace: "nowrap",
                              fontWeight: 500,
                              fontSize: "16px",
                              lineHeight: "100%",
                              letterSpacing: "-0.4px"
                            }}
                          >
                            {val?.name}:{' '}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              color: "#182A4E",
                              whiteSpace: "nowrap",
                              fontWeight: 500,
                              fontSize: "16px",
                              lineHeight: "100%",
                              letterSpacing: "-0.4px"
                            }}
                          >
                            {val?.value}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* Graph */}
            <Box
              sx={{
                width: { xs: "100%", md: 220 },
                height: 180,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mx: { md: 2 },
                mt: { xs: 2, md: 0 },
                flexShrink: 0,
              }}
            >
              <HighchartsReact highcharts={Highcharts} options={options} />
            </Box>
          </Box>
        )}
      </Box>
      {open &&

        <RiskPopup title={'Active Risk Distribution Package'} value={popupData.name} status={'package'} onOpen={open} onClose={() => setOpen(false)} />

      }
    </>

  );
};

export default RiskDistributionGraph;